import React from "react"
import { Window, View, Text, Input, Status } from "react-ame-components"

export class StatusExample extends React.Component {
  state = {
    inputValue: "",
    statusText: "",
    showStatus: false,
    typeStatus: "",
  }

  getInputValue = text => {
    this.setState({ inputValue: text })
    if (text.length < 8) {
      this.setState({ statusText: "Recusado" })
      this.setState({ showStatus: true })
      this.setState({ typeStatus: "error" })
    } else if (text.length > 13) {
      this.setState({ statusText: "Em validação" })
      this.setState({ typeStatus: "warning" })
    } else {
      this.setState({ statusText: "Validado" })
      this.setState({ typeStatus: "success" })
    }
  }
  render() {
    return (
      <Window>
        <View margin="medium">
          <Text target="title">Status</Text>
          <View marginTop="medium">
            <View direction="row">
              <Text>Contrato social</Text>
              <Status
                show={this.state.showStatus}
                type={this.state.typeStatus}>
                {this.state.statusText}
              </Status>
            </View>
            <Input
              placeholder="Teste Status"
              value={this.state.inputValue}
              onChange={e => this.getInputValue(e)}
            />
          </View>
        </View>
      </Window>
    )
  }
}
